<template>
  <div class="">
    <navbar></navbar>

    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / {{$t('OrderListTop.OrderList')}}
          <div class="card mt-4">
            <div class="card-body">
              <nav class="navbar pr-lg-3 pl-lg-3 p-0">
                <div class="col-12 col-lg-auto pl-0 pr-0 mr-0 text-left">
                  <label class="navbar-brand col-auto pl-0 pr-0 mt-2" for="No">{{$t('SearchColumn.NO')}}</label>
                  <div class="btn-group form-group mb-3 mt-1 col-auto pl-0 pr-0 ml-0" style="float:right">
                    <input type="text" class="form-control" style="min-width:225px;" v-model="orderNo" @blur="trimOrderNo" id="No">
                  </div>
                </div>
                <div class="col-12 col-lg-auto mr-0 pl-0 pr-0 text-left">
                  <label class="navbar-brand col-auto pl-0 pr-0 mt-2" for="dropdownMenuReference">{{$t('SearchColumn.Status')}}</label>
                  <div class="btn-group form-group mb-3 mt-1 col-auto pl-0 pr-0 ml-0" style="float:right">
                    <button type="button" id="selected" class="btn btn-outline-secondary" data-toggle="dropdown" style="min-width:200px;">{{status?getStatus(status):$t('SearchColumn.All')}}</button>
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" id="dropdownMenuReference" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent">
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuReference">
                      <button class="dropdown-item" @click="status=null">{{$t('SearchColumn.All')}}</button>
                      <button class="dropdown-item" @click="status=state" v-for="state in statusAmount" :key="state">{{getStatus(state)}}</button>
                    </div>
                  </div>
                </div>
                <div class="col-12 mb-3 mb-lg-0 col-lg-2 pl-0 pr-0 mr-0 text-right">
                  <div class="btn-group mb-3 mt-1 col-8 col-lg-10 pl-0 pr-0 ml-0 justify-content-end">
                    <button class="btn btn-outline-primary" style="max-width:225px;" @click="search">{{$t('SearchColumn.search')}}</button>
                  </div>
                </div>
              </nav>
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>{{$t('SearchColumn.NO')}}</th>
                      <th>{{$t('DisplayBar.Application')}}</th>
                      <th>{{$t('DisplayBar.UpdateTime')}}</th>
                      <th>{{$t('SearchColumn.Status')}}</th>
                    </tr>
                  </thead>
                  <tbody id="myTable">
                    <tr v-for="order in showOrderList" :key="order.order_id">
                      <td>
                        <a href="javascript:void(0);" style="font-family:Consolas;font-size:large;" @click="jumpToDetails(order.order_no)">{{order.order_no}}</a>
                      </td>
                      <td>{{moment(order.order_apply_time).format('YYYY-MM-DD HH:mm:ss')}}</td>
                      <td>{{moment(order.order_update_time).format('YYYY-MM-DD HH:mm:ss')}}</td>
                      <td>{{getStatus(order.order_status_code)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 text-right" style="height:20px">
                <small v-if="showLimited" class="text-danger">{{$t('orderlist.limit')}}</small>
              </div>
              <div class="row pl-0 pr-0">
                <!--<nav class="col-12 col-md-6 pl-0 pr-0 justify-content-center justify-content-md-start">
                  <label for="myInput" class="navbar-brand col-2 ml-0 mr-0">{{$t('DisplayBar.filter')}}</label>
                  <div class="btn-group form-group col-9 pr-0 pl-0 ml-0 mr-0 mt-2">
                    <input type="text" class="form-control pr-0 pl-0 ml-0 mr-0" id="myInput" v-model="filterInput" @blur="trimFilterInput">
                  </div>
                </nav>-->
                <nav class="col-12 col-lg-12 mt-2">
                  <ul class="pagination justify-content-center justify-content-md-end">
                    <li class="page-item"><button class="page-link" @click="pageNum = 1" :disabled="pageNum === 1" v-if="maxPageNum!==0">{{$t('DisplayBar.FirstButton')}}</button></li>
                    <li class="page-item"><button class="page-link" @click="pageNum--" :disabled="pageNum === 1" v-if="maxPageNum!==0">{{$t('DisplayBar.PreviousButton')}}</button></li>
                    <li class="page-item" v-for="page in maxPageNum" :class="{'active':page === pageNum}" :key="page"><button v-if="isShow(page)" class="page-link" @click="pageNum = page">{{page}}</button></li>
                    <li class="page-item"><button class="page-link" @click="pageNum++" :disabled="pageNum === maxPageNum" v-if="maxPageNum!==0">{{$t('DisplayBar.NextButton')}}</button></li>
                    <li class="page-item"><button class="page-link" @click="pageNum = maxPageNum" :disabled="pageNum === maxPageNum" v-if="maxPageNum!==0">{{$t('DisplayBar.LastButton')}}</button></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
  </div>
</template>

<style />

<script type="text/javascript">
import navbar from './navbar'
import copyright from '../user/copyright'
import { NmsClient, RestCfg } from '../../scripts/AllExport'
let orderQueryType = 'operator-order-query'

const moment = require('moment')
export default {
  components: { navbar, copyright },
  data: function () {
    return {
      status: null,
      statusAmount: ['AC', 'GU', 'WC', 'C', 'RA', 'CR', 'PC'],
      orderList: '',
      showOrderList: '',
      filteredList: '',
      maxListNum: 6,
      pageNum: 1,
      maxPageNum: 0,
      orderNo: '',
      showLimited: false,
      filterInput: '',
      moment: moment
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    jumpToDetails(orderNo) {
      this.$router.push({
        name: 'operatororderinfo',
        query: {
          'order_no': orderNo
        }
      })
    },
    getStatus (status) {
      switch (status) {
        case 'AC':
          return this.$t('status.AC')
        case 'GU':
          return this.$t('status.GU')
        case 'WC':
          return this.$t('status.WC')
        case 'C':
          return this.$t('status.C')
        case 'RA':
          return this.$t('status.RA')
        case 'CR':
          return this.$t('status.CR')
        case 'PC':
          return this.$t('status.PC')
      }
    },
    search() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': orderQueryType,
          'order_no': this.orderNo,
          'order_status_code': this.status
        },
        (response) => {
          this.orderList = response.resultInfo
          this.filteredList = this.orderList
          if (this.orderList.length >= 1000) this.showLimited = true
          else this.showLimited = false
          this.filterInput = ''
        },
        null
      )
    },
    showOrder() {
      if (this.filteredList.length <= this.pageNum * this.maxListNum) {
        this.showOrderList = this.filteredList.slice((this.pageNum - 1) * this.maxListNum)
      } else this.showOrderList = this.filteredList.slice((this.pageNum - 1) * this.maxListNum, this.pageNum * this.maxListNum)
    },
    reset() {
      this.maxPageNum = Math.ceil(this.filteredList.length / this.maxListNum)
      this.pageNum = 1
      this.showOrder()
    },
    isShow(page) {
      let pageNow = this.pageNum
      let maxPageNum = this.maxPageNum
      if (page <= pageNow) {
        if (page + 1 >= pageNow) return true
        else if (pageNow > maxPageNum - 1) {
          if (page - maxPageNum + pageNow + 2 >= pageNow) return true
          else return false
        } else return false
      } else {
        if (page - 1 <= pageNow) return true
        else if (pageNow < 2) {
          if (page - 3 <= 0) return true
          else return false
        } else return false
      }
    },
    trimOrderNo() {
      this.orderNo = this.orderNo.trim()
    },
    trimFilterInput() {
      this.filterInput = this.filterInput.trim()
    }
  },

  watch: {
    pageNum () {
      this.showOrder()
    },
    filteredList() {
      this.reset()
    },
    filterInput() {
      var value = this.filterInput.trim().toLowerCase()
      this.filteredList = this.orderList.filter((item, index, arr) => {
        return (item.order_no.toLowerCase().indexOf(value) > -1) || (this.getStatus(item.order_status_code).toLowerCase().indexOf(value) > -1) || (item.order_apply_time.toLowerCase().indexOf(value) > -1) || (item.order_update_time.toLowerCase().indexOf(value) > -1)
      })
    }
  }
}

</script>
<style scoped>
.navbar {
    font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}

#myTable tr td a{
  border-color: -webkit-link;
}
.container{
  min-height:calc(100vh - 256px)
}
</style>



// WEBPACK FOOTER //
// src/components/operator/order-list.vue